import { WeighingType } from "../../../../domain/model/weighing-type";
import { StoreApprovalStatus } from "./store-approval-status";
import { DataStoreId } from "../../data-store-id.type";
import { StoreUpdateInfo } from "../../../store-update-info";
import { PigGender } from "../../../../domain/model/pig-gender.type";
import { Uuid } from "../../../../domain/model/uuid/uuid.type";

export class StoreBatchWeighing implements DataStoreId {
  readonly id: string;
  readonly batchId: string;
  readonly sectionId: string;
  readonly trialId: string;
  readonly sequenceNumber: number;
  readonly animalWeighingIds: string[];
  readonly approvals: StoreApprovalStatus[];
  readonly weighingType: WeighingType;
  readonly gender: PigGender;
  readonly updateInfo: StoreUpdateInfo;

  constructor(
    id: Uuid,
    batchId: Uuid,
    sectionId: Uuid,
    trialId: Uuid,
    sequenceNumber: number,
    animalWeighingIds: string[],
    approvals: StoreApprovalStatus[],
    weighingType: WeighingType,
    gender: PigGender,
    updateInfo: StoreUpdateInfo
  ) {
    this.id = id.asString();
    this.batchId = batchId.asString();
    this.sectionId = sectionId.asString();
    this.trialId = trialId.asString();
    this.sequenceNumber = sequenceNumber;
    this.animalWeighingIds = animalWeighingIds;
    this.approvals = approvals;
    this.weighingType = weighingType;
    this.gender = gender;
    this.updateInfo = updateInfo;
  }
}
